import { Moment } from 'moment';
import * as React from 'react';

interface DateTimeProps {
  readonly date: Moment;
  readonly format: string;
}

export function DateView(props: DateTimeProps) {
  return (
    <span title={props.date.clone().utc().format()}>
      {props.date.format(props.format)}
    </span>
  );
}



// WEBPACK FOOTER //
// ../node_modules/source-map-loader!./src/components/widgets/date-view.tsx